module.exports = __webpack_public_path__ + "img/background-study-facility-location@2x.65eaa1b8.jpg";